import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProductComponent } from './product.component';
import { AuthGuard } from 'app/guards/auth.guard';
import { RouterModule, Routes } from '@angular/router';
import { CoreCommonModule } from '@core/common.module';
import { ContentHeaderModule } from 'app/layout/components/content-header/content-header.module';
import { ProductListComponent } from './product-list/product-list.component';
import { BlockUIModule } from 'ng-block-ui';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CreateProductComponent } from './create-product/create-product.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DetailProductComponent } from './detail-product/detail-product.component';
import { CoreDirectivesModule } from '@core/directives/directives';

const routes: Routes = [
  {
    path: 'product',
    component: ProductComponent,
    canActivate:[AuthGuard],
    data: { animation: 'auth' },
  },
  {
    path: 'create-product',
    component: CreateProductComponent,
    canActivate:[AuthGuard],
    data: { animation: 'auth' },
  },
  {
    path: 'detail-product/:id',
    component: DetailProductComponent,
    canActivate:[AuthGuard],
    data: { animation: 'auth' },
  },
];

@NgModule({
  declarations: [
    ProductComponent,
    ProductListComponent,
    CreateProductComponent,
    DetailProductComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    CoreCommonModule,
    ContentHeaderModule,
    BlockUIModule.forRoot(),
    NgxDatatableModule,
    NgbModule,
    NgSelectModule,
    FormsModule,
    ReactiveFormsModule,
    CoreDirectivesModule
  ]
})
export class ProductModule { }
